function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Karma_icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ToDoList_Dashboard",
  transform: "translate(-38.000000, -267.000000)"
}, React.createElement("g", {
  id: "Sidebar"
}, React.createElement("g", {
  id: "Karma",
  transform: "translate(38.000000, 266.000000)"
}, React.createElement("g", {
  id: "Karma_icon",
  transform: "translate(0.000000, 1.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  className: "iconStroke",
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15,
  rx: 4
}), React.createElement("path", {
  d: "M4.23888889,2.48888889 L8.53333333,2.48888889 L8.53333333,2.48888889 L8.53333333,13.5111111 L4.23888889,13.5111111 C3.27239058,13.5111111 2.48888889,12.7276094 2.48888889,11.7611111 L2.48888889,4.23888889 C2.48888889,3.27239058 3.27239058,2.48888889 4.23888889,2.48888889 Z",
  id: "Rectangle-Copy-9",
  className: "iconFill"
}))))));

var SvgKarmaIcon = function SvgKarmaIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKarmaIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Karma_icon.9672d67e.svg";
export { ForwardRef as ReactComponent };